<template>
  <div class="patient-medical-record">
    <!-- 顶部筛选区域 -->
    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-item">
          <label>就诊时间</label>
          <el-date-picker
            v-model="filterForm.visitDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            size="small"
            class="date-picker"
          >
          </el-date-picker>
        </div>
        
        <div class="filter-item">
          <label>医生</label>
          <el-select v-model="filterForm.doctorId" placeholder="请选择医生" size="small" class="select-input">
            <el-option
              v-for="item in doctorList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        
        <div class="filter-buttons">
          <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          <el-button size="small" @click="handleReset"> <i class="el-icon-refresh"></i>重置</el-button>
        </div>
      </div>
    </div>
    
    <!-- 表格列表 -->
    <div class="table-section">
      <el-table 
        ref="medicalTable"
        :data="currentPageData" 
        style="width: 100%"
        :header-cell-style="{background: '#f5f7fa', color: '#606266'}"
        border
        v-loading="loading"
        element-loading-text="正在加载病历记录..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="examTime" label="就诊时间" width="150" align="center">
          <template slot-scope="scope">
            <span class="exam-time"  @click="openDialog(scope.row)">{{ scope.row.examTime }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="doctor" label="医生" width="120" align="center">
          <template slot-scope="scope">
            <span class="doctor-text">{{ scope.row.doctor }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="symptom" label="病症" align="center">
          <template slot-scope="scope">
            <span class="symptom-text">{{ scope.row.symptom }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="type" label="门店" align="center">
          <template slot-scope="scope">
            <span class="type-text">{{ scope.row.type }}</span>
          </template>
        </el-table-column>

<!--        <el-table-column label="操作" width="120" align="center" fixed="right">-->
<!--          <template slot-scope="scope">-->
<!--            <el-link type="primary" :underline="false" @click="openDialog(scope.row)">详情</el-link>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    
    <!-- 分页组件 -->
    <div class="pagination-section">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        background
      >
      </el-pagination>
    </div>

    <!-- 自定义内容弹框（空白，供后续自定义） -->
    <el-dialog
      title="门诊详情"
      :visible.sync="showDialog"
      width="1000px"
      append-to-body
    >
      <div class="custom-dialog-body" v-loading="loading">

        <div class="outpatientInfoBox">
          <div class="timeBox">
            <div class="time">{{ medicalRecordInfo.visitDate || '--' }}</div>
            <div class="local">{{ medicalRecordInfo.hospitalName || '--' }}</div>
          </div>
          <div class="rightBox">
            <div class="rightInfo">
              医生：{{ medicalRecordInfo.doctorName || '--' }}
            </div>
            <div class="rightInfo">
              就诊号：{{ selectedRow ? selectedRow.id : '--' }}
            </div>
            <div class="printBtn" @click="printPatientInfoToImage()">打印</div>
          </div>
        </div>
        <div class="contentBody" ref="patientInfoCard">
          <div class="contentMarsk" v-if="0"></div>
          <div class="outpatientBoxTableBox">
            <div class="row" style="border: none">
              <div class="title">病历</div>
            </div>
            <div class="row">
              <div class="label">主诉</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.readme"/>
              </div>
            </div>
            <div class="row">
              <div class="label">病程</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.present"/>
              </div>
            </div>
            <div class="row">
              <div class="label">现病史</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.presentHistory"/>
              </div>
            </div>
            <div class="row">
              <div class="label">既往史</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.pastHistory"/>
              </div>
            </div>
            <div class="row">
              <div class="label">家族史</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.familyHistory"/>
              </div>
            </div>
            <div class="row">
              <div class="label">过敏史</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.allergy"/>
              </div>
            </div>
            <div class="row">
              <div class="label">个人史</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.personalHistory"/>
              </div>
            </div>
            <div class="row">
              <div class="label">望切</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.observationAndPalpation"/>
              </div>
            </div>
            <div class="row">
              <div class="label">出生史</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.birthHistory"/>
              </div>
            </div>
            <div class="row">
              <div class="label">流行病史</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.epidemics"/>
              </div>
            </div>
            <div class="row">
              <div class="label">体格检查</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.physique"/>
              </div>
            </div>
            <div class="row">
              <div class="label">西医检查</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.auxiliaryExamination"/>
              </div>
            </div>
            <div class="row">
              <div class="label">主症</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.mainSymptoms"/>
              </div>
            </div>
          </div>
          <div class="outpatientBoxTableBox">
            <div class="row" style="border: none">
              <div class="label">辨证要点</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.dialecticalGovernance" />
              </div>
            </div>
            <div class="row">
              <div class="label">体质</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.constitution" />
              </div>
            </div>
            <div class="row">
              <div class="label">病症</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.diagnosis" />
              </div>
              <div class="label" style="border-left: 1px solid #e0e5ee">辨证</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.dialectic" />
              </div>
            </div>
            <div class="row">
              <div class="label">治法</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.therapy" />
              </div>
              <div class="label" style="border-left: 1px solid #e0e5ee">方药</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.prescriptionMedicine" />
              </div>
            </div>
            <div class="row">
              <div class="label">处置</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled v-model="medicalRecordInfo.treat" />
              </div>
            </div>
          </div>
          <div class="outpatientBoxTableBox">
            <div class="row" style="border: none">
              <div class="label">睡眠建议</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled :value="parsedDoctorAdvice.sleepAdviceObj ? parsedDoctorAdvice.sleepAdviceObj.sleepDietaryAdvice : ''" />
              </div>
            </div>
            <div class="row">
              <div class="label">睡眠环境建议</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled :value="parsedDoctorAdvice.sleepAdviceObj ? parsedDoctorAdvice.sleepAdviceObj.sleepEnvAdvice : ''" />
              </div>
            </div>
            <div class="row">
              <div class="label">运动建议</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled :value="parsedDoctorAdvice.exerciseAdviceObj ? parsedDoctorAdvice.exerciseAdviceObj.pmExerciseAdvice : ''" />
              </div>
            </div>
            <div class="row">
              <div class="label">茶饮建议</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled :value="parsedDoctorAdvice.teaAdviceObj ? parsedDoctorAdvice.teaAdviceObj.teaAdvice : ''" />
              </div>
            </div>
            <div class="row">
              <div class="label">改善建议</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled :value="parsedDoctorAdvice.improveAdviceObj ? parsedDoctorAdvice.improveAdviceObj.improveAdvice1 : ''" />
              </div>
            </div>
            <div class="row">
              <div class="label">饮食建议</div>
              <div class="input-wrapper">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" disabled :value="parsedDoctorAdvice.dietaryAdviceObj ? parsedDoctorAdvice.dietaryAdviceObj.dietaryAdvice : ''" />
              </div>
            </div>
          </div>
          <div class="outpatientBoxTableBox">
            <div class="row" style="border: none">
              <div class="title">处方医嘱</div>
            </div>
            <div class="row" style="display:flex;align-items: center;border-top: 1px solid #e0e5ee">
              <img class="icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAA81BMVEUAAAD79Oz68e368ur68er58ur58ur68ur68ur58ur68en68un58er68+r/+PD68er68+r68er58em/iFD3sWnw4NDXtI/Jmmn47+Xo0r3Ai1T37ePw4tPt28jUr4jRqH/Lnm/EkFz06Nvx5NXky7HixqvgxKfcvJzPpXnwrGbkpGHGlGHy5djmz7f4063NoXTXmVvCjVfEi1Lr2MTq1sLjxajat5L4xZH3voTVrIHPo3f3tW/3sGjzr2fqqGPMkVbFj1b36t346Nb44Mf52rrkyKz4zaP4y53hvZf3yJbcuZXas4vasIf4u37Xq37SonHFkFnObM9HAAAAEnRSTlMARDj87ufZw7+tpZmDbSLzkPJOv6aZAAAB2ElEQVQ4y51V13aCQBDFjoKNsSAqgr3F3mOM6b38/9dEyrKLLHLCfdl2z5w7ZWeYcwT5BBtNZ6Nsgg8yFxHgIgKBCBdwpQZjggMxuvlUXKAinqIoCAsuCDu0JEOCK0JJOzcjXETGZlfwQJLQG/IihyzdKRffqoVaIY+8RDFxiVkbNFyhCJq5oHNLMJiLJVWqm2cjOzEqt65KmoQmtFEude/ohmsGqwoddKP5yFG5Lejqawea6Io7kSM0bmWqDvVVGohWDbq5p5hRGBsrcpGncTsgm2JqxC3PJGjZgEFZW4dTtU5cJxjWyS0XYWFGpEnes0zU2ucRZOiWNHRgrB0tQpRJo20DXNBAjDSTxUKVggF5XDTQPR0UqCJGFsuogCxQIEMFy2AttySFJD2M1puvzXpUlMrYQRy6HVZ3/3KdM9CDHRE6niiHlbG5e8tZmMASJ4VItziY6vXwqFtFhn9FnG6ykJqgnPQ95zBubuEJNzN7iRagWx/Zud/4lbMXv1gDtb9H1H1/Bj8ifg2cf6u2BLNJ/9DrHfqTGcAr2SKdH7bycQQTx88G+RKktQJxsVxtt++t+VkzxU3GE+HUf9qXv8bo3XL9N3PvMeF/AHmPNv9DkxzHaeo4/gPUT3lLu1Rs9AAAAABJRU5ErkJggg==" alt="">
              <div class="label" style="border: none">{{ item.prescriptionName || '中药处方' }}</div>
              <div class="medicineTotalBox" v-if="herbalDetails.length">{{ herbalDetails.length }}味</div>
            </div>
            <div class="row" style="flex-wrap: wrap;border-top: 1px solid #e0e5ee">
              <div class="medicineItemsVBox" v-for="(herb, index) in herbalDetails" :key="index">
                <el-input :value="herb.herbalName" disabled/>
                <el-input style="width: 90px" :value="herb.dosage" disabled/>
              </div>
            </div>
            <div class="row" style="border-top: none">
              <div class="optionRow">
                <div style="width: 90px; display: flex; align-items: center;">
                  <el-input :value="item.payNumber" disabled style="width: 100%;"></el-input>
                </div>
                <div class="label" style="min-width: 50px;width: 50px">剂</div>
                <div style="width: 90px; display: flex; align-items: center;">
                  <el-input :value="getZYYFLabel(item.usageMode)" disabled placeholder="用法" style="width: 100%;"></el-input>
                </div>
                <div style="width: 120px; display: flex; align-items: center;">
                  <el-input :value="getJLLabel(item.dailyDosage)" disabled placeholder="剂量" style="width: 100%;"></el-input>
                </div>
                <div style="width: 120px; display: flex; align-items: center;">
                  <el-input :value="getZYPLLabel(item.frequency)" disabled placeholder="频率" style="width: 100%;"></el-input>
                </div>
                <div style="width: 120px; display: flex; align-items: center;" v-if="item.usageMode !=='ZG' && item.usageMode !=='ZW' && item.usageMode !=='DF'">
                  <el-input :value="getZYCGFYLLabel(item.dosage)" disabled placeholder="服用量" style="width: 100%;"></el-input>
                </div>
                <div style="width: 120px; display: flex; align-items: center;" v-if="item.usageMode ==='ZG' || item.usageMode ==='ZW'">
                  <el-input :value="getFYLLabel(item.dosage)" disabled placeholder="服用量" style="width: 100%;"></el-input>
                </div>
                <div style="width: 120px; display: flex; align-items: center;" v-if="item.usageMode ==='ZG' || item.usageMode ==='ZW' || item.usageMode ==='DF'">
                  <el-input :value="getZYFYTSLabel(item.usageDays)" disabled placeholder="服用天数" style="width: 100%;"></el-input>
                </div>
                <div style="width: 200px; display: flex; align-items: center;">
                  <el-input :value="item.remark" disabled placeholder="备注" style="width: 100%;"></el-input>
                </div>
              </div>
            </div>
          </div>

          <div class="AIyfTip">
            <i style="line-height: 32px;margin-top: 1px;margin-right: 2px" class="el-icon-warning-outline"></i>本回答由AI生成，内容仅供参考，具体药物的用法用量需中医师调整配伍
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="closeButton" @click="showDialog = false">关闭</div>
<!--        <el-button @click="showDialog = false">取 消</el-button>-->
<!--        <el-button type="primary" @click="showDialog = false">确 定</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {get, post} from "@/api/api";
import html2canvas from 'html2canvas';
export default {
  name: "patientMedicalRecord",
  props: {
    selectedPatient: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      // 筛选表单
      filterForm: {
        visitDate: '',
        doctor: ''
      },
      item:{},
      // 药品明细列表
      herbalDetails: [],
      medicineTypeList :[
        {
          value: 1,
          label: '饮片'
        },
        {
          value: 2,
          label: '冲剂'
        }
      ],
      JL:[], //剂量
      ZYYF:[], //服用方式
      ZYPL:[], //服用频率
      ZYCGFYL:[], // 服用量（煎服，冲服，外用，贴敷）
      ZYDFFYL:[], // 服用量（打粉）
      ZYZWFYL:[], // 服用量（制丸）
      ZYZGFYL:[], // 服用量 （制膏）
      ZYFYTS:[], // 服用天数
      medicalRecordInfo: {},
      // API相关状态
      loading: false,
      medicalRecords: [], // 从API获取的病历记录
      // 表格数据
      tableData: [
        {
          examTime: '2025-07-16 14:23',
          doctor: '张医生',
          symptom: '胃病',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-07-16 09:53',
          doctor: '李医生',
          symptom: '感冒',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-07-14 13:16',
          doctor: '王医生',
          symptom: '胃痛',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-07-08 10:29',
          doctor: '赵医生',
          symptom: '感冒',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-07-07 10:52',
          doctor: '陈医生',
          symptom: '胃病',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-06-14 14:26',
          doctor: '刘医生',
          symptom: '关节上呼吸道感染',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-06-11 16:22',
          doctor: '张医生',
          symptom: '感冒',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-05-19 11:21',
          doctor: '李医生',
          symptom: '关节上呼吸道感染',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-05-08 11:28',
          doctor: '王医生',
          symptom: '胃痛',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-04-29 14:23',
          doctor: '赵医生',
          symptom: '胃病',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-03-22 13:07',
          doctor: '陈医生',
          symptom: '关节上呼吸道感染',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-03-22 13:05',
          doctor: '刘医生',
          symptom: '关节上呼吸道感染',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-03-20 11:09',
          doctor: '张医生',
          symptom: '胃痛',
          type: 'ABC测试诊所'
        },
        {
          examTime: '2025-03-20 11:00',
          doctor: '李医生',
          symptom: '胃病',
          type: 'ABC测试诊所'
        }
      ],
      
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 14
      },
      
      // 原始数据备份（用于筛选）
      originalData: [],

      // 弹框控制与当前行
      showDialog: false,
      selectedRow: null,
      // 医生列表
      doctorList: []
    }
  },
  
  computed: {
    // 当前页显示的数据
    currentPageData() {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      return this.tableData.slice(start, end);
    },
    
    // 解析 doctorAdvice JSON 字符串
    parsedDoctorAdvice() {
      if (!this.medicalRecordInfo || !this.medicalRecordInfo.doctorAdvice) {
        return {}
      }
      try {
        const parsed = typeof this.medicalRecordInfo.doctorAdvice === 'string' 
          ? JSON.parse(this.medicalRecordInfo.doctorAdvice) 
          : this.medicalRecordInfo.doctorAdvice
        return parsed || {}
      } catch (e) {
        console.error('解析 doctorAdvice 失败:', e)
        return {}
      }
    }
  },
  watch: {
    // 监听选中患者变化
    selectedPatient: {
      handler(newPatient) {
        if (newPatient && newPatient.caseNumber) {
          console.log('患者变化，重新获取病历记录:', newPatient);
          this.getMedicalRecords(newPatient.caseNumber);
        } else {
          // 清空病历记录
          this.tableData = [];
          this.medicalRecords = [];
          this.pagination.total = 0;
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getMetadataList();
    this.originalData = [...this.tableData];
    this.updatePagination();
    this.getDoctorList(); // 在mounted钩子中调用获取医生列表的方法
  },
  
  methods: {
    getZYCGFYLLabel (code) {
      if (!code) return
      let name;
      this.ZYCGFYL.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      return name
    },
    getZYFYTSLabel (code) {
      if (!code) return
      let name;
      this.ZYFYTS.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      return name
    },
    getFYLLabel (code) {
      if (!code) return
      let name;
      this.ZYCGFYL.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      this.ZYDFFYL.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      this.ZYZWFYL.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      this.ZYZGFYL.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      return name
    },
    getZYYFLabel (code) {
      if (!code) return
      let name;
      this.ZYYF.map(item => {
       if (item.code === code) {
         name = item.name;
       }
      })
      return name
    },
    getJLLabel (code) {
      if (!code) return
      let name;
      this.JL.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      return name
    },
    getZYPLLabel (code) {
      if (!code) return
      let name;
      this.ZYPL.map(item => {
        if (item.code === code) {
          name = item.name;
        }
      })
      return name
    },
    printPatientInfoToImage(){
      this.captureAndDownload(this.$refs.patientInfoCard)
    },
    /**
     * 截取长DOM元素并下载为图片
     * @param {HTMLElement} domElement - 要截图的DOM元素
     * @param {string} fileName - 下载的文件名（带扩展名）
     * @param {Object} [options] - html2canvas配置选项
     */
    // 在captureAndDownload方法中添加文本域替换逻辑
    captureAndDownload(domElement, fileName = 'screenshot.png', options = {}) {
      this.loading = true;

      // 保存原始样式和滚动位置
      const computedStyle = window.getComputedStyle(domElement);
      const originalStyles = {
        position: domElement.style.position || computedStyle.position,
        overflow: domElement.style.overflow || computedStyle.overflow,
        height: domElement.style.height || computedStyle.height,
        width: domElement.style.width || computedStyle.width,
        display: domElement.style.display || computedStyle.display,
        transform: domElement.style.transform || computedStyle.transform
      };
      const originalScrollY = window.scrollY;

      try {
        // 临时修改元素样式
        domElement.style.position = 'absolute';
        domElement.style.overflow = 'visible';
        domElement.style.height = 'auto';
        domElement.style.width = 'auto';

        // 替换所有文本域为div
        const textareaReplacements = this.replaceTextareasWithDivs(domElement);

        // 获取完整尺寸
        const fullHeight = domElement.scrollHeight;
        const fullWidth = domElement.scrollWidth;

        // 设置截图选项
        const defaultOptions = {
          useCORS: true,
          allowTaint: true,
          scale: 2,
          width: fullWidth,
          height: fullHeight,
          scrollX: 0,
          scrollY: 0
        };
        const captureOptions = { ...defaultOptions, ...options };

        // 执行截图
        html2canvas(domElement, captureOptions)
            .then(canvas => {
              // 恢复文本域
              this.restoreTextareas(textareaReplacements);

              // 恢复原始样式
              this.restoreElementStyles(domElement, originalStyles);
              window.scrollTo(0, originalScrollY);

              // 强制重新渲染以确保样式完全恢复
              this.$nextTick(() => {
                // 触发重新布局
                domElement.style.display = 'none';
                domElement.offsetHeight; // 强制重排
                domElement.style.display = '';
              });

              // 创建下载链接
              const link = document.createElement('a');
              link.href = canvas.toDataURL('image/png');
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.loading = false;
            })
            .catch(error => {
              // 恢复文本域
              this.restoreTextareas(textareaReplacements);
              this.restoreElementStyles(domElement, originalStyles);
              window.scrollTo(0, originalScrollY);
              
              // 强制重新渲染以确保样式完全恢复
              this.$nextTick(() => {
                domElement.style.display = 'none';
                domElement.offsetHeight; // 强制重排
                domElement.style.display = '';
              });
              
              this.loading = false;
              console.error('截图失败:', error);
            });
      } catch (error) {
        this.restoreElementStyles(domElement, originalStyles);
        window.scrollTo(0, originalScrollY);
        
        // 强制重新渲染以确保样式完全恢复
        this.$nextTick(() => {
          domElement.style.display = 'none';
          domElement.offsetHeight; // 强制重排
          domElement.style.display = '';
        });
        
        this.loading = false;
        console.error('截图前处理失败:', error);
      }
    },
// 新增方法：替换文本域为div
    replaceTextareasWithDivs(container) {
      const replacements = [];
      const textareas = container.querySelectorAll('textarea');

      textareas.forEach(textarea => {
        // 创建替代div
        const div = document.createElement('div');
        div.textContent = textarea.value;

        // 复制样式
        const computedStyle = window.getComputedStyle(textarea);
        div.style.width = computedStyle.width;
        div.style.minHeight = computedStyle.height;
        div.style.padding = computedStyle.padding;
        div.style.border = computedStyle.border;
        div.style.fontFamily = computedStyle.fontFamily;
        div.style.fontSize = computedStyle.fontSize;
        div.style.lineHeight = computedStyle.lineHeight;
        div.style.whiteSpace = 'pre-wrap'; // 保留换行和空格
        div.style.wordBreak = 'break-word'; // 允许单词内换行
        div.style.overflowWrap = 'break-word'; // 长单词换行

        // 设置类名和属性
        div.className = textarea.className;
        div.setAttribute('data-original-id', textarea.id);

        // 隐藏原始文本域并插入div
        textarea.style.display = 'none';
        textarea.parentNode.insertBefore(div, textarea);

        // 保存替换信息
        replacements.push({
          textarea,
          div
        });
      });

      return replacements;
    },

// 新增方法：恢复文本域
    restoreTextareas(replacements) {
      replacements.forEach(replacement => {
        // 移除div并显示原始文本域
        replacement.div.remove();
        replacement.textarea.style.display = '';
      });
    },
    /**
     * 恢复元素原始样式
     * @param {HTMLElement} element - DOM元素
     * @param {Object} styles - 原始样式对象
     */
    restoreElementStyles(element, styles) {
      // 恢复所有保存的样式属性
      element.style.position = styles.position === 'static' ? '' : styles.position;
      element.style.overflow = styles.overflow === 'visible' ? '' : styles.overflow;
      element.style.height = styles.height === 'auto' ? '' : styles.height;
      element.style.width = styles.width === 'auto' ? '' : styles.width;
      element.style.display = styles.display === 'block' ? '' : styles.display;
      element.style.transform = styles.transform === 'none' ? '' : styles.transform;
    },
    getPatientInfoDetial (row) {
      this.loading = true;
      get(`/operation/medicalRecord/management/getDetail/${row.id}`).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data;
          // 字段拼接逻辑
          // 现病史：diet, sleepChronicles, urinate, stool, emotion, period, sweating, coldAndHeat, presentOther
          const presentHistory = [
            data.diet ? '饮食：' + data.diet : '',
            data.sleepChronicles ? '睡眠：' + data.sleepChronicles : '',
            data.urinate ? '小便：' + data.urinate : '',
            data.stool ? '大便：' + data.stool : '',
            data.emotion ? '情志：' + data.emotion : '',
            data.period ? '经期：' + data.period : '',
            data.sweating ? '汗出：' + data.sweating : '',
            data.coldAndHeat ? '寒热：' + data.coldAndHeat : '',
            data.presentOther ? '其他：' + data.presentOther : ''
          ].filter(item => item && item.trim()).join('；');

          // 既往史：takenMedications, history
          const pastHistory = [
            data.takenMedications ? '曾服用药：' + data.takenMedications : '',
            data.history ? '既往史：' + data.history : ''
          ].filter(item => item && item.trim()).join('；');

          // 望切：tongueDiagnosis, pulseDiagnosis, observationDiagnosis
          const observationAndPalpation = [
            data.tongueDiagnosis ? '舌诊：' + data.tongueDiagnosis : '',
            data.pulseDiagnosis ? '脉诊：' + data.pulseDiagnosis : '',
            data.observationDiagnosis ? '面诊：' + data.observationDiagnosis : ''
          ].filter(item => item && item.trim()).join('；');
          
          // 保存病历基本信息
          this.medicalRecordInfo = {
            visitDate: data.visitDate,
            hospitalName: data.hospitalName,
            doctorName: data.doctorName,
            readme: data.readme,
            present: data.present, // 病程
            presentHistory: presentHistory, // 拼接后的现病史
            pastHistory: pastHistory, // 拼接后的既往史
            allergy: data.allergy,
            familyHistory: data.familyHistory,
            personalHistory: data.personalHistory,
            observationAndPalpation: observationAndPalpation, // 拼接后的望切
            birthHistory: data.birthHistory,
            epidemics: data.epidemics,
            physique: data.physique,
            auxiliaryExamination: data.auxiliaryExamination,
            mainSymptoms: data.mainSymptoms,
            dialecticalGovernance: data.dialecticalGovernance,
            constitution: data.constitution,
            diagnosis: data.diagnosis,
            dialectic: data.dialectic,
            therapy: data.therapy,
            prescriptionMedicine: data.prescriptionMedicine,
            treat: data.treat,
            doctorAdvice: this.parseDoctorAdvice(data.doctorAdvice), // 解析医嘱JSON字符串
            // 保留原始字段用于调试
            coldAndHeat: data.coldAndHeat,
            diet: data.diet,
            sleepChronicles: data.sleepChronicles,
            emotion: data.emotion,
            sweating: data.sweating,
            urinate: data.urinate,
            stool: data.stool,
            presentOther: data.presentOther,
            takenMedications: data.takenMedications,
            history: data.history,
            observationDiagnosis: data.observationDiagnosis,
            tongueDiagnosis: data.tongueDiagnosis,
            pulseDiagnosis: data.pulseDiagnosis
          };
          
          // 保存处方信息
          if (data.herbalPrescriptionInfo && data.herbalPrescriptionInfo.length > 0) {
            const prescription = data.herbalPrescriptionInfo[0];
            this.item = {
              prescriptionName: prescription.prescriptionName,
              payNumber: prescription.payNumber,
              usageMode: prescription.usageMode,
              dailyDosage: prescription.dailyDosage,
              frequency: prescription.frequency,
              dosage: prescription.dosage,
              usageDays: prescription.usageDays,
              remark: prescription.remark
            };
            
            // 处理药品明细
            this.herbalDetails = prescription.herbalDetails || [];
          } else {
            // 清空处方信息
            this.item = {};
            this.herbalDetails = [];
          }
        }
        this.loading = false;
      }).catch(err => {
        console.error('获取病历详情失败:', err);
        this.$message.error('获取病历详情失败，请稍后重试');
        this.loading = false;
      });
    },
    // 解析 doctorAdvice JSON 字符串
    parseDoctorAdvice(advice) {
      if (!advice) {
        return null;
      }
      
      // 如果已经是对象，直接返回
      if (typeof advice === 'object') {
        return advice;
      }
      
      // 如果是字符串，尝试解析 JSON
      if (typeof advice === 'string') {
        try {
          return JSON.parse(advice);
        } catch (e) {
          console.error('解析 doctorAdvice JSON 失败:', e);
          return null;
        }
      }
      
      return null;
    },
    //获取字典
    getMetadataList () {
      get('/common/constantItem/getConstantList').then(res=>{
        let data =  res.data.data
        this.JL = data.JL
        this.ZYYF = data.ZYYF //服用方式
        this.ZYCGFYL = data.ZYCGFYL// 服用量（煎服，冲服，外用，贴敷）
        this.ZYDFFYL = data.ZYDFFYL// 服用量（打粉）
        this.ZYZWFYL = data.ZYZWFYL// 服用量（制丸）
        this.ZYZGFYL = data.ZYZGFYL// 服用量 （制膏）
        this.ZYFYTS = data.ZYFYTS//服用天数
        this.ZYPL = data.ZYPL//频率
      })
    },
    // 获取医生列表
    async getDoctorList() {
      this.loading = true;
      try {
        const response = await get('/operation/patient/management/getDoctors');
        if (response.data && response.data.code === 200) {
          this.doctorList = response.data.data || [];
        } else {
          this.$message.error(response.data?.msg || '获取医生列表失败');
          this.doctorList = [];
        }
      } catch (error) {
        console.error('获取医生列表失败:', error);
        this.$message.error(error?.msg);
        this.doctorList = [];
      } finally {
        this.loading = false;
      }
    },

    
    // 获取病历记录
    async getMedicalRecords(caseNumber) {
      if (!caseNumber) {
        console.warn('病历号为空，无法获取病历记录');
        return;
      }
      
      this.loading = true;
      try {
        const userInfo = JSON.parse(localStorage.getItem('User'));
        const params = {
          caseNumber: caseNumber,
          doctorId: this.filterForm.doctorId,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          startDate: this.filterForm.visitDate[0],
          endDate:  this.filterForm.visitDate[1]
        };
        
        // 过滤空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === null || params[key] === undefined || params[key] === '') {
            delete params[key];
          }
        });

        const response = await post('/operation/medicalRecord/management/page', params);
        console.log('不是运营端')
        if (response.data && response.data.code === 200) {
          const data = response.data.data;
          this.medicalRecords = data.list || [];
          this.pagination.total = data.total || 0;
          
          // 将API数据转换为表格显示格式
          this.tableData = this.medicalRecords.map(record => ({
            id: record.id,
            examTime: this.formatDate(record.visitDate),
            doctor: record.doctorName || '',
            symptom: record.diagnosis || '',
            type: record.hospitalName || '',
            originalData: record // 保存原始数据用于详情显示
          }));

        } else {
          this.$message.error(response.data?.msg || '获取病历记录失败');
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (error) {
        console.error('获取病历记录失败:', error);
        this.$message.error('获取病历记录失败，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    
    // 格式化日期用于API请求
    formatDateForAPI(date, isStart) {
      if (!date) return null;
      const d = new Date(date);
      if (isStart) {
        // 开始时间设为当天00:00:00
        d.setHours(0, 0, 0, 0);
      } else {
        // 结束时间设为当天23:59:59
        d.setHours(23, 59, 59, 999);
      }
      return d.toISOString().slice(0, 19).replace('T', ' ');
    },
    
    // 格式化日期显示
    formatDate(dateStr) {
      if (!dateStr) return '';
      try {
        const date = new Date(dateStr);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateStr;
      }
    },
    // 搜索功能
    handleSearch() {
      // 如果有选中患者，使用API搜索
      if (this.selectedPatient && this.selectedPatient.caseNumber) {
        this.pagination.currentPage = 1; // 重置到第一页、
        this.getMedicalRecords(this.selectedPatient.caseNumber);
        return;
      }
      
      // 否则使用原有的本地搜索逻辑
      let filteredData = [...this.originalData];
      
      // 按就诊日期时间筛选
      if (this.filterForm.visitDate) {
        const selectedDateTime = new Date(this.filterForm.visitDate);
        filteredData = filteredData.filter(item => {
          const itemDateTime = new Date(item.examTime);
          return itemDateTime.getTime() === selectedDateTime.getTime();
        });
      }
      
      // 按医生筛选
      if (this.filterForm.doctor) {
        filteredData = filteredData.filter(item => item.doctor && item.doctor.includes(this.filterForm.doctor));
      }
      
      this.tableData = filteredData;
      this.pagination.total = filteredData.length;
      this.pagination.currentPage = 1;
      this.updatePagination();
    },
    
    // 重置功能
    handleReset() {
      this.filterForm = {
        visitDate: '',
        doctor: ''
      };
      this.tableData = [...this.originalData];
      this.pagination.total = this.originalData.length;
      this.pagination.currentPage = 1;
      this.updatePagination();
      this.getMedicalRecords(this.selectedPatient.caseNumber);
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      console.log( this.selectedPatient.caseNumber);
      
      // 如果有选中患者，重新调用API
      if (this.selectedPatient && this.selectedPatient.caseNumber) {
        this.getMedicalRecords(this.selectedPatient.caseNumber);
      } else {
        this.updatePagination();
      }
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      
      // 如果有选中患者，重新调用API
      if (this.selectedPatient && this.selectedPatient.caseNumber) {
        this.getMedicalRecords(this.selectedPatient.caseNumber);
      } else {
        this.updatePagination();
      }
    },
    
    // 更新分页显示
    updatePagination() {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      
      // 获取当前应该显示的数据
      let currentData = this.tableData;
      if (this.tableData.length > this.pagination.pageSize) {
        currentData = this.tableData.slice(start, end);
      }
      
      // 更新表格显示的数据
      this.$nextTick(() => {
        // 强制更新表格
        this.$refs.medicalTable && this.$refs.medicalTable.doLayout();
      });
    },
    
    // 获取当前页显示的数据
    getCurrentPageData() {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      return this.tableData.slice(start, end);
    },

    // 打开弹框
    openDialog(row) {
      this.selectedRow = row || null;
      this.getPatientInfoDetial(this.selectedRow)
      this.showDialog = true;
    },

    // 医生下拉框变化时触发
    handleDoctorChange(value) {
      // 如果选择了某个医生，则将该医生的名字设置到filterForm.doctor
      // 同时，如果选中患者存在，则重新获取病历记录
      if (value) {
        this.filterForm.doctor = value;
        if (this.selectedPatient && this.selectedPatient.caseNumber) {
          this.pagination.currentPage = 1;
          this.getMedicalRecords(this.selectedPatient.caseNumber);
        }
      } else {
        // 如果清空，则清空filterForm.doctor
        this.filterForm.doctor = '';
      }
    }
  }
}
</script>

<style lang="less" scoped>
.custom-dialog-body {
  padding: 10px;
  overflow: hidden;
  .contentBody{
    height: 62vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 5px 30px 0;
    position: relative;
    .contentMarsk{
      position: absolute;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100%;
      background-color: transparent;
      z-index: 1;
    }
  }
  .outpatientInfoBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(0,0,0,.5);
    padding: 5px 0;
    .timeBox {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .rightBox {
      display: flex;
      align-items: center;
      gap: 10px;
      .rightInfo{
        display: flex;
      }
      .printBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #1ec761;
        color: white;
        font-weight: bold;
        border-radius: 5px;
        height: 28px;
        width: 75px;
        font-size: 14px;
        user-select: none;
        cursor: pointer;
      }
    }
  }
  .outpatientBoxTableBox {
    border: 2px solid #f2f2f2;
    border-radius: 14px;
    background-color: #f9fafc;
    margin-top: 10px;
    .row{
      display: flex;
      width: 100%;
      min-height: 43px;
      border: 1px solid #e0e5ee;
      border-bottom: none;
      box-sizing: border-box;
      display: flex;
      align-items: stretch;
      position: relative;
      border-left: none;
      border-right: none;
      .icon{
        height: 24px;
        width: 24px;
        margin-left: 7px;
      }
      .title {
        padding-left: 10px;
        color: #000;
        font-weight: bold;
        flex: 1;
        display: flex;
        align-items: center;
      }
      .label{
        display: flex;
        align-items: center;
        width: 98px;
        min-width: 98px;
        padding-left: 10px;
        text-align: left;
        border-right: 1px solid #e0e5ee;
        color: #595959;
        font-weight: bold;
        font-family: inherit;
      }
      .input-wrapper {
        position: relative;
        display: inline-block;
        width: 100%;
        /deep/ .el-textarea__inner::placeholder {
          line-height: 37px;
        }
        /deep/ .el-textarea__inner {
          width: 100%;
          border-radius: 0;
          min-height: 43px !important;
          resize: none !important;
          background-color: rgba(0,0,0,0);
          border: 1px solid rgba(0,0,0,0);
          box-sizing: border-box;
          color: #595959;
          font-weight: bold;
          font-family: inherit;
          //font-size: 1px;
          line-height: 37px;
          //border-left: 1px solid #e0e5ee;
          //&:focus {
          //  border-color: #0270c9;
          //  box-shadow: 0 0 0 2px #c3e0fe;
          //}
          //&:hover {
          //  border-color: #0270c9;
          //}
          //border-left: 1px solid #e0e5ee;
        }
      }
      .medicineTotalBox {
        margin-left: 10px;
        font-size: 13px;
        color: #b7bfc6;
      }
      .medicineItemsVBox:nth-child(4n) {
        border-right: none;
      }
      .medicineItemsVBox {
        display: flex;
        width: 25%;
        align-items: center;
        border-right: 1px solid #e0e5ee;
        padding-right: 5px;
        flex-shrink: 0;
        box-sizing: border-box;
      }
      /deep/ .el-input__inner {
        background: transparent;
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
        min-height: 43px !important;
        color: #595959 !important;
        font-weight: 700 !important;
      }
      /deep/ .el-form-item {
        margin-bottom: 0;
      }
      .optionRow{
        min-height: 43px !important;
        display: flex;
        align-items: center;
      }
    }
    .el-input__icon {
      line-height: 30px;
    }
  }
}

.patient-medical-record {
  padding: 20px;
  background: #fff;
}

/* 筛选区域样式 */
.filter-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-item label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
  min-width: 60px;
}

.date-picker {
  width: 240px;
}

.select-input {
  width: 120px;
}

.input-field {
  width: 150px;
}

.filter-buttons {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

/* 表格区域样式 */
.table-section {
  margin-bottom: 20px;
}

.exam-time {
  color: #409eff;
  font-size: 12px;
  font-weight: normal;
  cursor: pointer;
}

.doctor-text {
  color: #606266;
  font-size: 12px;
  font-weight: 500;
}

.symptom-text {
  color: #606266;
  font-size: 12px;
}

.type-text {
  color: #909399;
  font-size: 12px;
}

/* 分页区域样式 */
.pagination-section {
  display: flex;
  justify-content: flex-start;
  padding: 15px 0;
  margin-top: 10px;
}

/* Element UI 组件样式覆盖 */
::v-deep .el-table {
  font-size: 12px;
  border: 1px solid #ebeef5;
}

::v-deep .el-table th {
  background: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 500;
  font-size: 12px;
  height: 40px;
  padding: 8px 0;
}

::v-deep .el-table td {
  padding: 6px 0;
  height: 35px;
  font-size: 12px;
}

::v-deep .el-table .cell {
  padding: 0 8px;
}

::v-deep .el-pagination {
  font-size: 12px;
}

::v-deep .el-pagination .el-pager li {
  font-size: 12px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
}

::v-deep .el-pagination .btn-prev,
::v-deep .el-pagination .btn-next {
  font-size: 12px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
}

::v-deep .el-date-editor .el-range-input {
  font-size: 12px;
}

::v-deep .el-select .el-input__inner {
  font-size: 13px;
  height: 32px;
  line-height: 32px;
  font-weight: 600;
}

::v-deep .el-input__inner {
  font-size: 13px;
  height: 32px;
  line-height: 32px;
  font-weight: 600;
}

::v-deep .el-button {
  font-size: 12px;
  padding: 8px 15px;
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid rgba(0,0,0,.08);
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
  overflow-y: auto;
}
::v-deep .el-dialog {
  border-radius: 30px;
  border: 1px solid #ebeef5;
  box-shadow: none;
  margin-top: 5vh !important;
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    padding: 0 20px;
    .closeButton {
      border: 2px solid #ebeef5;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1e5b9a;
      font-size: 14px;
      font-weight: 700;
      user-select: none;
      border-radius: 5px;
      height: 28px;
      width: 75px;
      cursor: pointer;
    }
  }

}
::v-deep .el-input.is-disabled .el-input__inner {
  color: #595959;
}
::v-deep .el-dialog__title {
  font-weight: 700;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  display: none;
}
.AIyfTip{
  width: auto;
  height: 32px;
  border: 1px solid var(--error-color) !important;
  background-color: var(--error-color2) !important;
  color: var(--error-color);
  display: flex;
  align-items: center;
  //justify-content: center;
  padding-left: 20px;
  margin: 15px;
  border-radius: 5px;
}
</style>